import { useState, useEffect } from "react";

function useLocalStorage<T>(
  key: string,
  defaultValue: T
): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    const storedValue = window.localStorage.getItem(key);
    return storedValue !== null ? JSON.parse(storedValue) : defaultValue;
  });

  useEffect(() => {
    window.localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  useEffect(() => {
    //TODO:hmm
    const checkStorage = () => {
      const storedValue = window.localStorage.getItem(key);
      if (storedValue !== null) {
        setValue(JSON.parse(storedValue));
      }
    };

    const intervalId = setInterval(checkStorage, 250);
    return () => clearInterval(intervalId);
    //const handleStorageChange = (event: StorageEvent) => {
    //console.log("storage changed", event);
    //if (event.key === key && event.newValue !== null) {
    //setValue(JSON.parse(event.newValue));
    //}
    //};
    //window.addEventListener("storage", handleStorageChange);
    //return () => window.removeEventListener("storage", handleStorageChange);
  }, [key]);

  //useEffect(() => {
  //console.log("useLocalStorage changed ", value);
  //}, [value]);

  return [value, setValue];
}

export default useLocalStorage;
